<template>
  <div id="notfound">
    <div class="notfound">
      <div class="notfound-404">
        <h1>404</h1>
      </div>
      <h2>{{ $t('notFound.title') }}</h2>
      <form class="notfound-search" @submit.prevent="submit"  v-if="$route.params.withoutGoBack!=true">
        <input type="text" :placeholder="$t('labels.search')" v-model="keyword" />
        <button type="submit">{{ $t('buttons.search') }}</button>
      </form>

      <span v-if="$route.params.withoutGoBack!=true" class="router-link-active a" @click="goBack"> <span class="arrow"></span>{{ $t('notFound.go_back') }} </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'errorPage',
  components: {},
  data() {
    return {
      keyword: '',
    };
  },
  methods: {
    goBack(){
        this.$router.push({ name: 'index' });
    },
    submit() {
      const route = { name: 'home' };
      route.params = { category: 'all' };
      if (this.keyword) {
        route.query = { q: this.keyword };
      }
      this.$router.push(route);
    },
  },
  created() {

    console.log("route.params",this.$route.params)
  },
};
</script>
<style lang="scss">
@import '../assets/scss/_variables.scss';

$color_french_rose_approx: var(--primary-color);
$color_log_cabin_approx: #222;
$color_alabaster_approx: #f8fafb;
$color_log_cabin_20_approx: rgba(34, 34, 34, 0.2);
$white: #fff;
$color_pelorous_approx: var(--secondary-color);

#notfound {
  position: relative;
  height: 100vh;
  .notfound {
    position: absolute;
    left: 50%;
    top: 50%;
    //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)
    transform: translate(-50%, -50%);
  }
}
.notfound {
  max-width: 710px;
  width: 100%;
  text-align: center;
  padding: 0 15px;
  line-height: 1.4;
  .notfound-404 {
    height: 200px;
    line-height: 200px;
    h1 {
      font-size: 168px;
      margin: 0;
      color: $color_french_rose_approx;
      text-transform: uppercase;
    }
  }
  h2 {
    font-size: 22px;
    font-weight: 400;
    text-transform: uppercase;
    color: $color_log_cabin_approx;
    margin: 0;
  }
  .a {
    cursor: pointer;
    display: inline-block;
    font-weight: 700;
    //Instead of the line below you could use @include border-radius($radius, $vertical-radius)
    border-radius: 15px;
    text-decoration: none;
    color: $color_pelorous_approx;
    > .arrow {
      position: relative;
      top: -2px;
      border: solid $color_pelorous_approx;
      border-width: 0 3px 3px 0;
      display: inline-block;
      padding: 3px;
      //Instead of the line below you could use @include transform($scale, $rotate, $transx, $transy, $skewx, $skewy, $originx, $originy)
      transform: rotate(135deg);
    }
  }
}
.notfound-search {
  position: relative;
  padding-right: 123px;
  max-width: 420px;
  width: 100%;
  margin: 30px auto 22px;
  input {
    width: 100%;
    height: 40px;
    padding: 3px 15px;
    color: $color_log_cabin_approx;
    font-size: 18px;
    background: $color_alabaster_approx;
    border: 1px solid $color_log_cabin_20_approx;
    //Instead of the line below you could use @include border-radius($radius, $vertical-radius)
    border-radius: 3px;
  }
  button {
    position: absolute;
    right: 0;
    top: 0;
    width: 120px;
    height: 40px;
    text-align: center;
    border: none;
    background: $color_french_rose_approx;
    cursor: pointer;
    padding: 0;
    color: $white;
    font-weight: 700;
    font-size: 18px;
    //Instead of the line below you could use @include border-radius($radius, $vertical-radius)
    border-radius: 3px;
  }
}
@media only screen and(max-width: 767px) {
  .notfound .notfound-404 {
    height: 122px;
    line-height: 122px;
    h1 {
      font-size: 122px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ErrorPage.vue